(function() {
    'use strict';
    angular
        .module('abcQualityMatchApp')
        .factory('TicketState', TicketState);

    TicketState.$inject = ['$resource'];

    function TicketState ($resource) {
        var resourceUrl =  'api/ticket-states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
